export enum UiStatus {
  Info,
  Success,
  Warning,
  Error,
}
